module.exports = __webpack_public_path__ + "static/media/fk-vitebsk.d4645d4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/fk-vitebsk.svg
// module id = 529
// module chunks = 0